import SocialNetworkProvider from './hooks/useSocialNetwork';

import { SocialNetworkProps } from './@types/SocialNetworkProps';
import SocialNetworkContainer from './handles/SocialNetworkContainer';
import SocialNetworkWrapper from './handles/SocialNetworkWrapper';
import SocialNetworkLink from './handles/SocialNetworkLink';
import SocialNetworkTitle from './handles/SocialNetworkTitle';

const SocialNetwork = (props: SocialNetworkProps) => (
	<SocialNetworkProvider {...props}>
		<SocialNetworkWrapper>
			{props.title && props.title.length > 0 && <SocialNetworkTitle>{props.title}</SocialNetworkTitle>}
			<SocialNetworkContainer>
				{props.socialNetworks?.map((item, index) => (
					<SocialNetworkLink
						socialNetworks={item}
						showInColor={props.showInColor}
						blockClass={props.blockClass}
						key={`${item.name}-${index}`}
					/>
				))}
			</SocialNetworkContainer>
		</SocialNetworkWrapper>
	</SocialNetworkProvider>
);

export default SocialNetwork;
